/**
 * The admin's toast policy, applied to every toast however it is raised
 * (`useToastFeedback` or a direct `useToast().add`).
 *
 * WCAG 2.2.1 Timing Adjustable, 4.1.3 Status Messages (audit A26): an error
 * toast that dismisses itself after a few seconds can take the only copy of
 * the error with it ("Failed to load categories"). Hover pauses a toast;
 * keyboard and screen-reader users have no such pause. So an error stays
 * until it is dismissed with its close button. Success, info and warn toasts
 * keep their timed life.
 */
import type { ToastMessageOptions } from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import type { App } from 'vue';

export function applyToastPolicy(message: ToastMessageOptions): ToastMessageOptions {
  return message.severity === 'error' ? { ...message, life: undefined } : message;
}

/** PrimeVue's ToastService, with `add` routed through `applyToastPolicy`. */
export const AdminToastService = {
  install(app: App) {
    app.use(ToastService);
    // useToast() injects this same object, so one wrap covers every caller.
    const service = app.config.globalProperties.$toast;
    const add = service.add.bind(service);
    service.add = (message: ToastMessageOptions) => add(applyToastPolicy(message));
  },
};
